var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"spinner"}},[_c('div',{attrs:{"id":"spinnerWrap"}},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Large Spinner"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }